import { ReactComponent as ZhuanyecanzhaoSvg } from '@/commons/icons/menu/zhuanyecanzhao.svg';
import { ReactComponent as ZhouxianSvg } from '@/commons/icons/menu/zhouxian.svg';
import { ReactComponent as YinyongloucengSvg } from '@/commons/icons/menu/yinyonglouceng.svg';
import { ReactComponent as YinyongzhouwangSvg } from '@/commons/icons/menu/yinyongzhouwang.svg';

import { ReactComponent as JishuiguanSvg } from '@/commons/icons/menu/water/jishuiguan.svg';
import { ReactComponent as PaishuiguanSvg } from '@/commons/icons/menu/water/paishuiguan.svg';
import { ReactComponent as PaishuikouSvg } from '@/commons/icons/menu/water/paishuikou.svg';
import { ReactComponent as SantongSvg } from '@/commons/icons/menu/water/santong.svg';
import { ReactComponent as ShangshuikouSvg } from '@/commons/icons/menu/water/shangshuikou.svg';
import { ReactComponent as ShuiguanfamenSvg } from '@/commons/icons/menu/water/shuiguanfamen.svg';
import { ReactComponent as ShuilongtouSvg } from '@/commons/icons/menu/water/shuilongtou.svg';
import { ReactComponent as ShuixiangSvg } from '@/commons/icons/menu/water/shuixiang.svg';
import { ReactComponent as WantouSvg } from '@/commons/icons/menu/water/wantou.svg';
import { ReactComponent as XiashuikouSvg } from '@/commons/icons/menu/water/xiashuikou.svg';

export default function WaterMenu() {

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongzhouwangSvg /></div>
                                <div className='name'>引用轴网</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhouxianSvg /></div>
                                <div className='name'>轴线</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongloucengSvg /></div>
                                <div className='name'>引用楼层</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhuanyecanzhaoSvg /></div>
                                <div className='name'>专业参照</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><ShangshuikouSvg /></div>
                                <div className='name'>上水口</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><ShuixiangSvg /></div>
                                <div className='name'>水箱</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><ShuiguanfamenSvg /></div>
                                <div className='name'>阀门</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><JishuiguanSvg /></div>
                                <div className='name'>给水管</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><WantouSvg /></div>
                                <div className='name'>弯头</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><SantongSvg /></div>
                                <div className='name'>三通</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><ShuilongtouSvg /></div>
                                <div className='name'>水龙头</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><PaishuikouSvg /></div>
                                <div className='name'>排水口</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><PaishuiguanSvg /></div>
                                <div className='name'>排水管</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><XiashuikouSvg /></div>
                                <div className='name'>下水口</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}